import axios from './axios'

export const removeAttachment = (attachId, personId) =>
  axios.delete(`/attachments/${attachId}?person_id=${personId}`)

export const editAttachment = (attachId, personId, params) =>
  axios.putJson(`/attachments/${attachId}?person_id=${personId}`, params)
